import { Blockchain } from "@anaconda/core/blockchain/types"

export const getFeaturedBlockchain = () => Blockchain.ETHEREUM
